import React from 'react';
import { Link, graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Thumbnail from '../components/thumbnail';
import Header from '../components/header';

const IndexPage = ({ data }) => {
  let makes = data.allDataJson;
  return (
    <Layout>
      <SEO
        title="Home"
        keywords={[
          `carousell`,
          `singapore new cars`,
          `singapore motors`,
          `carousell motors`,
          `singapore makes`,
          `singapore autos`
        ]}
      />
      <Header siteTitle={data.site.siteMetadata.title} />
      {makes.edges.map(({ node }) => {
        // create reference to logo file
        let make = {
          ...node,
          imagePath: `logo-${node.slug}.jpg`,
          newImagePath: `make_${node.slug}@5x.png`
        };
        return (
          <Link key={make.slug} to={make.slug}>
            <Thumbnail data={make} />
          </Link>
        );
      })}
    </Layout>
  );
};

export default IndexPage;

export const query = graphql`
  query {
    allDataJson {
      edges {
        node {
          make
          slug
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;
